/* eslint-disable jsx-a11y/mouse-events-have-key-events */
'use client';
import { useState, useEffect, useRef } from 'react';
import { PLAYWRIGHT_IGNORE } from '@/lib/constants';
import { TestimonialStats } from '@/components/TestimonialStats';
import SelectLogoTiles from '@/sections/customers/FeaturedStoriesSection/SelectLogoTiles';
import { featuredStories } from './featuredStories.copy';

interface FeaturedStoriesSectionProps {}

export const FeaturedStoriesSection: React.FC<FeaturedStoriesSectionProps> = () => {
  const [featuredStoryIdx, setFeaturedStoryIdx] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setFeaturedStoryIdx((featuredStoryIdx + 1) % featuredStories.length);
    }, 4000);

    if (isHovering) {
      clearInterval(intervalRef.current);
    }
    return () => clearInterval(intervalRef.current);
  }, [featuredStoryIdx, isHovering]);

  return (
    <section className="py-section h-full bg-light-background-100 px-4 text-gray-1 md:px-10 lg:px-20 xl:px-20">
      <div className="m-auto flex max-w-7xl flex-col">
        <h2 className="text-h3 mb-8 md:mb-12 lg:mb-16 xl:mb-16">Dive deeper</h2>
        <div
          className="flex w-full flex-col gap-8 md:gap-14 lg:flex-row-reverse lg:gap-20 xl:flex-row-reverse xl:gap-20"
          data-testid={PLAYWRIGHT_IGNORE}
        >
          <div
            className="flex w-full lg:flex-[3] xl:flex-[3]"
            onMouseOver={() => setIsHovering(true)}
            onMouseOut={() => setIsHovering(false)}
          >
            {featuredStories[featuredStoryIdx].background}
          </div>
          <div className="flex flex-col gap-6 md:flex-row md:gap-10 lg:flex-1 lg:flex-col lg:gap-14 xl:flex-1 xl:flex-col xl:gap-14">
            {featuredStories[featuredStoryIdx].bullets.map((bullet, idx) => (
              <TestimonialStats
                key={`item_${idx}`}
                stat={bullet.stat}
                description={bullet.description}
                variant="light"
              />
            ))}
          </div>
        </div>
        <SelectLogoTiles selectedTileIdx={featuredStoryIdx} handleSelectStory={setFeaturedStoryIdx} />
      </div>
    </section>
  );
};
